import {
  applyOfficialPlayoffOutcomes as applyShared,
  OverlayPickerSurface,
} from '../shared/official-playoff-overlay';

export type { OverlayPickerSurface };

/**
 * NHL canonical round-name → priority. Server emits these strings from
 * NhlPlayoffSource.MapRound (C#).
 */
export const NHL_ROUND_ORDER: Record<string, number> = {
  FirstRound: 1,
  SecondRound: 2,
  ConferenceFinal: 3,
  StanleyCupFinal: 4,
};

/**
 * Applies official NHL playoff outcomes to the picker bracket.
 * Delegates to the shared algorithm in src/shared/official-playoff-overlay.ts
 * with NHL_ROUND_ORDER. The picker import in schedule-picker.ts is unchanged
 * (still imports from './official-playoff-overlay' with 2 args).
 */
export function applyOfficialPlayoffOutcomes(
  picker: OverlayPickerSurface,
  playoffs: ILeaguePlayoffs
): void {
  applyShared(picker, playoffs, NHL_ROUND_ORDER);
}
